<template>
	<div>
		<b-img src="/images/importer/module-penetrables/penetrables.jpg"></b-img>
		<p>
			Penetrables are any hole on your character that can be penetrated - Mouth, Pussy, or Ass. The Penetrables module does not currently contain any fields of its own, just instructions on 
			setting up Penetrables on your character from the available prefabs. Once added, select the penetrable object in your character for more information on setting up its child components.
			You can also check the Example scene for a working example of how the various child objects of the Penetrable are configured on a real character.
		</p>
        
		<p>
			<span class="font-weight-bold">Has Rear-Facing Genitals:</span> This flag appears for Feral characters and should be set if the character has rear-facing genitals, such as on a
			gryphon or horse, as opposed to downward-facing genitals like the Drake. This flag is used by the game's interaction studio to create animation variants to prevent alignment
			issues with these different body types.
		</p>
	</div>
</template>

<script>
export default {
		name: 'PenetrablesModule',
}
</script>
